import { render } from "./PaymentMethod.vue?vue&type=template&id=6750bce6&scoped=true"
import script from "./PaymentMethod.vue?vue&type=script&lang=js"
export * from "./PaymentMethod.vue?vue&type=script&lang=js"

import "./PaymentMethod.vue?vue&type=style&index=0&id=6750bce6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6750bce6"]])

export default __exports__